import { render, staticRenderFns } from "./ModalBoardCommand.vue?vue&type=template&id=ca2b6ace&scoped=true"
import script from "./ModalBoardCommand.vue?vue&type=script&lang=js"
export * from "./ModalBoardCommand.vue?vue&type=script&lang=js"
import style0 from "./ModalBoardCommand.vue?vue&type=style&index=0&id=ca2b6ace&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2b6ace",
  null
  
)

export default component.exports